import { useQuery, UseQueryResult } from 'react-query';
import {
  BankAccountResponse,
  FETCH_BANK_ACCOUNTS,
  FetchBankAccountsSchemaContract,
} from 'api/employeeBankAccount';
import api from 'api';
import { AppError } from 'utils/AppError';
import { useUserId } from './useUserId';
import { bankAccountApprovalStatus } from '../data';

export const useGetBankAccountDetails = (): {
  isEditLimitExceeded: boolean;
  queryResponse: UseQueryResult<FetchBankAccountsSchemaContract>;
  latestBankAccount?: BankAccountResponse;
  accountHistory?: BankAccountResponse[];
} => {
  const userId = useUserId();

  const queryResponse = useQuery(
    [FETCH_BANK_ACCOUNTS, userId],
    () => {
      return userId
        ? api.employeeBankAccount.fetchBankAccounts({
            user_id: userId,
            limit: 20,
          })
        : Promise.reject('User is not logged in');
    },
    {
      onError: (error: typeof AppError) => {
        //do nothing
      },
    },
  );

  const accounts = queryResponse.data?.data.items ?? [];

  const pendingOnApprovalAccount = accounts?.find(
    (account) => account.approval_status === bankAccountApprovalStatus.pending,
  );
  const activeAccount = accounts?.find((account) => account.is_active);

  const latestBankAccount = pendingOnApprovalAccount ?? activeAccount ?? undefined;

  const bankAccountHistory = accounts?.filter((account) => account.id !== latestBankAccount?.id);

  return {
    isEditLimitExceeded: queryResponse.data?.data.meta?.is_penny_testing_limit_exceeded ?? false,
    latestBankAccount,
    accountHistory: bankAccountHistory,
    queryResponse,
  };
};
